import { ResponsivePie } from '@nivo/pie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatInteger } from '../../../common/formatHelper';
import { OrdersStatusRow } from '../../types/metrics';

interface OrdersStatusChartProps {
  data: OrdersStatusRow[];
}

const OrdersStatusChart: React.FC<OrdersStatusChartProps> = ({ data }) => {
  const { t } = useTranslation('app');

  // Transform data for pie chart
  const pieData = data.reduce(
    (acc, curr) => {
      const existingStatus = acc.find(item => item.id === curr.status);
      if (existingStatus) {
        existingStatus.value += curr.orderCount;
      } else {
        acc.push({
          id: curr.status,
          label: t(curr.status),
          value: curr.orderCount,
        });
      }
      return acc;
    },
    [] as { id: string; label: string; value: number }[],
  );

  return (
    <div className="bg-app-panel-dark h-[400px] rounded-lg p-4">
      <h3 className="mb-4 text-lg font-semibold text-white">
        {t('Orders Status Distribution')}
      </h3>
      <ResponsivePie
        data={pieData}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.6}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        colors={{ scheme: 'category10' }}
        borderWidth={1}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 0.2]],
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="rgba(255, 255, 255, 0.9)"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor="rgba(255, 255, 255, 0.9)"
        valueFormat={value => formatInteger(value)}
        legends={[
          {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: 'rgba(255, 255, 255, 0.9)',
            itemDirection: 'left-to-right',
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: 'circle',
          },
        ]}
      />
    </div>
  );
};

export default OrdersStatusChart;
